var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "career margin-t-2" }, [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c(
        "div",
        { ref: "width", staticClass: "container-fluid" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-info",
              attrs: {
                to: {
                  name: "talent.profile.show",
                  params: { id: this.userId },
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(" Back\n      "),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", { staticClass: "border-none" }, [
          _vm._v("What are you famous for?"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticClass: "spacer-y-1 lead-text" }, [
              _vm._v("Search by industry, profession, sport or club"),
            ]),
            _vm._v(" "),
            _c("tag-picker", {
              attrs: {
                "input-id": "search",
                current: _vm.nodes,
                "full-width": true,
                "with-icon": true,
                "with-popper": true,
                placeholder: "Search",
                "default-fetch": true,
              },
              on: { selected: _vm.handleSearchSelected },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.nodes.length || _vm.underReview.length
          ? _c(
              "div",
              { staticClass: "bg-white margin-t-3 spacer-x-4 spacer-y-4" },
              [
                _vm._l(_vm.nodes, function (node) {
                  return _c("profile-career-tags-list-item", {
                    key: node.id,
                    attrs: { node: node, current: _vm.nodes },
                    on: {
                      selected: _vm.handleSelected,
                      delete: _vm.handleDetachNode,
                      toggleRetired: _vm.handleToggleRetired,
                    },
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.underReview, function (tag) {
                  return _c(
                    "div",
                    {
                      key: tag.id,
                      staticClass: "flex flex-col career-list-item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "career-list-item__row flex flex-row justify-between",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "career-list-item__row--header" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tag.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-row" },
                            [
                              _vm._v(
                                "\n              Is this current?\n              "
                              ),
                              _c("toggle-button", {
                                staticClass: "margin-x-2",
                                attrs: {
                                  sync: true,
                                  color: {
                                    checked: _vm.brandPrimary,
                                    unchecked: "#b7b7b7",
                                  },
                                  labels: { checked: "YES", unchecked: "NO" },
                                },
                                on: {
                                  input: (value) => {
                                    _vm.handleToggleRetiredPending(tag, value)
                                  },
                                },
                                model: {
                                  value: tag.current,
                                  callback: function ($$v) {
                                    _vm.$set(tag, "current", $$v)
                                  },
                                  expression: "tag.current",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "delete-button" }, [
                                _c("i", {
                                  staticClass: "fa fa-times",
                                  on: {
                                    click: () => {
                                      _vm.handleDeletePendingTag(tag)
                                    },
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "career-list-item__row career-list-item__row--highlight",
                        },
                        [_vm._v("\n            Under Review\n          ")]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "spacer-t-4" }, [
                  _c(
                    "span",
                    {
                      staticClass: "cursor-pointer add-button add-button--bold",
                      on: { click: _vm.focusSearch },
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" Add Another"),
                    ]
                  ),
                ]),
              ],
              2
            )
          : _c(
              "div",
              {
                staticClass:
                  "flex justify-center align-center bg-white spacer-y-4 spacer-x-2 margin-t-3",
              },
              [
                _c(
                  "button",
                  { staticClass: "add-button", on: { click: _vm.focusSearch } },
                  [_vm._v("Add your first industry")]
                ),
                _vm._v("to be more recognisable\n      "),
              ]
            ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid footer-container",
        class: _vm.fixed ? "fixed" : "relative",
        style:
          "max-width: " + _vm.width + "px;" + "min-width: " + _vm.width + "px",
      },
      [
        _c("div", { staticClass: "flex footer" }, [
          _c("div", { staticClass: "hidden-xs" }, [
            _vm._v(
              "\n        Select 1 or more industry tags that apply\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row align-center" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    to: {
                      name: "talent.profile.show",
                      params: { id: this.userId },
                    },
                  },
                },
                [_vm._v("\n          Confirm\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "spacer-b-2 lead-text" }, [
        _vm._v(
          "Select roles, past or present, that you are most well known for"
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex flex-row flex-wrap gray-500 w-2/3 justify-between",
        },
        [
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              {
                staticClass: "flex justify-start align-center",
                staticStyle: { width: "30px" },
              },
              [_c("i", { staticClass: "fa fa-search" })]
            ),
            _vm._v(" Appear in more searches"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              {
                staticClass: "flex justify-start align-center",
                staticStyle: { width: "30px" },
              },
              [_c("i", { staticClass: "fa fa-line-chart" })]
            ),
            _vm._v(" Get more profile views"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              {
                staticClass: "flex justify-start align-center",
                staticStyle: { width: "30px" },
              },
              [_c("i", { staticClass: "fa fa-user-plus" })]
            ),
            _vm._v(" Be recommended for more opportunities"),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }